export enum NewMatchCheckingFrequency {
    realtime = 3721,
    daily = 3722
}